import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';

const Link = React.forwardRef(function Link(
	props,
	ref
) {
	let {
		href,
		to,
		external,
		component,
		children,
		text,
		...rest
	} = props;
	if (to !== undefined && href === undefined) href = to;
	const isExternal =
		typeof external === 'boolean'
			? external
			: href === undefined || href === '#' || /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(href);

	const content = children || text;

	if (isExternal) {
		return (
			<a ref={ref} href={href || to} {...rest}>
				{content}
			</a>
		);
	}

	const InternalComponent = component || GatsbyLink;
	return (
		<InternalComponent
			ref={ref}
			to={to || href}
			{...rest}
		>
			{content}
		</InternalComponent>
	);
});

export default Link;
